import type { VFC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { LoginPage } from './LoginPage';

export const PublicRouter: VFC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      {/* NOTE: route to LoginPage needs to be last and match every path */}
      <Route path={path} render={() => <LoginPage />} />
    </Switch>
  );
};
